import Vue from 'vue';
import packageOrderProductTransformer from './../../transformers/packageOrderProduct';

const success = (resolve, response) => {
  resolve(packageOrderProductTransformer.fetch(response.data));
};

const failed = (errors, reject) => {
  if (errors.error) {
    reject(errors.error);
    return;
  }

  reject(packageOrderProductTransformer.fetch(errors));
};

export default (id, packageOrderProduct) => (
  new Promise((resolve, reject) => {
    Vue.$http.put(`/packageOrderProduct/${id}`, packageOrderProductTransformer.send(packageOrderProduct))
    .then((response) => {
      success(resolve, response);
    })
    .catch((error) => {
      failed(error.response.data, reject);
    });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/packageOrderProduct/update.js